import { FC } from 'react';

import color from 'atoms/colors/colors';

// Quarks
import Flex from 'quarks/Flex';
import Text from 'quarks/Text';

import ComponentButton from 'components/Button/ComponentButton';
import checklistRichTextParser from 'components/Cards/ChecklistCard/checklistRichTextParser';

import type { ContentfulResourceCard } from 'graphqlTypes';

const ChecklistCard: FC<ContentfulResourceCard> = ({ body, backgroundIsDark, callToAction, ...props }) => (
  <Flex
    width="100%"
    height="100%"
    flexDirection="column"
    borderRadius="12px"
    border="1px solid"
    borderColor="gray-200"
    hover={{ boxShadow: 'xxl' }}
    transition="200ms ease-in-out"
    backgroundColor={backgroundIsDark ? 'gray-800' : 'common-white'}
    css={`
      button,
      a {
        padding-left: 0;
      }

      &:hover {
        cursor: pointer;
      }
    `}
    {...props}
  >
    <Flex
      position="relative"
      flexDirection="column"
      justifyContent="space-between"
      gap="16px"
      height="100%"
      maxHeight="fit-content"
      css={`
        padding: 2rem 2rem 7rem 2rem;
      `}
    >
      {body && (
        <Flex
          flexDirection="column"
          gap="16px"
          css={`
            .dark,
            .dark span {
              color: white;
            }
            h1,
            h2,
            h3,
            h4,
            h5,
            h6,
            p {
              color: ${color.gray[900]};
            }

            li p {
              color: ${color.gray[400]};
            }
          `}
        >
          <Text textStyle="textMd" className={backgroundIsDark ? 'dark' : 'light'}>
            {checklistRichTextParser(body)}
          </Text>
        </Flex>
      )}
      {callToAction && (
        <Flex
          gap="4px"
          alignItems="center"
          position="absolute"
          className="w-[calc(100%-60px)] bottom-8"
          css={`
            a {
              width: 100%;
            }
          `}
        >
          <ComponentButton {...callToAction} buttonColor="Garden 300" className="!w-full !max-w-full" />
        </Flex>
      )}
    </Flex>
  </Flex>
);

export default ChecklistCard;
